import * as React from 'react';
import { SelectAutocompleteContext } from './context/SelectAutocompleteContext.js';
import { useSelectAutocomplete } from './hooks/useSelectAutocomplete.js';

var SelectAutocomplete = /*#__PURE__*/React.memo(function (props) {
  var children = props.children;
  var _useSelectAutocomplet = useSelectAutocomplete(),
    inputRef = _useSelectAutocomplet.inputRef,
    collectionRef = _useSelectAutocomplet.collectionRef,
    textFieldProps = _useSelectAutocomplet.textFieldProps,
    collectionProps = _useSelectAutocomplet.collectionProps,
    filter = _useSelectAutocomplet.filter;
  return /*#__PURE__*/React.createElement(SelectAutocompleteContext.Provider, {
    value: {
      inputRef: inputRef,
      collectionRef: collectionRef,
      textFieldProps: textFieldProps,
      collectionProps: collectionProps,
      filter: filter
    }
  }, children);
});

export { SelectAutocomplete };
//# sourceMappingURL=SelectAutocomplete.js.map
